import {
  API_CALL, CLEAR_LOYALTY_MEMBER_SUBSCRIPTION,
} from './actionConstants'
import { FETCH_LOYALTY_PRODUCT_SUBSCRIPTION, FETCH_LOYALTY_MEMBER_SUBSCRIPTION } from './apiActionConstants'
import { getMemberSubscription, getSubscriptionOffer, getMemberSubscriptionPoll } from 'api/loyalty'
import { isLuxuryPlusEnabled } from 'loyalty/selectors/featureToggle'

export function fetchProductSubscription() {
  return (dispatch, getState) => {
    const state = getState() as App.State
    if (
      state.loyalty.products.subscription.offers ||
      state.loyalty.products.subscription.fetching ||
      state.loyalty.products.subscription.error
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_PRODUCT_SUBSCRIPTION,
      request: () => getSubscriptionOffer(state.geo.currentRegionCode),
    })
  }
}

interface FetchMemberSubscriptionParams {
  refetch?: boolean
  poll?: boolean
}

export function fetchMemberSubscription(params?: FetchMemberSubscriptionParams) {
  return (dispatch, getState) => {
    const state = getState() as App.State
    const memberId = state.auth.account.memberId

    if (!memberId || !isLuxuryPlusEnabled(state) || state.loyalty.member.subscription.fetching) {
      return
    }

    if (params?.refetch || !state.loyalty.member.subscription.error) {
      dispatch({
        type: API_CALL,
        api: FETCH_LOYALTY_MEMBER_SUBSCRIPTION,
        request: () => params?.poll ? getMemberSubscriptionPoll(memberId) : getMemberSubscription(memberId),
      })
    }
  }
}

export function clearMemberSubscription() {
  return {
    type: CLEAR_LOYALTY_MEMBER_SUBSCRIPTION,
  }
}
